var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2967,
    cy: 40.2967,
    r: 37.7782,
    fill: "#D7D4F8",
    stroke: "#845BB3",
    strokeWidth: 5.03709
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6438 41.7658V32.9509H50.5821V41.7658H47.6438ZM47.6438 47.6424V44.7041H50.5821V47.6424H47.6438ZM41.7672 41.7658V30.0126C41.7672 27.5151 39.8573 25.6052 37.3597 25.6052C34.8622 25.6052 32.9523 27.5151 32.9523 30.0126V41.7658C29.7201 44.2634 28.9856 48.8178 31.4831 52.0499C33.9807 55.282 38.535 56.0166 41.7672 53.519C44.9993 51.0215 45.7339 46.4671 43.2363 43.235C42.7956 42.6473 42.3548 42.2066 41.7672 41.7658ZM37.3597 28.5435C38.2412 28.5435 38.8289 29.1311 38.8289 30.0126V34.4201H35.8906V30.0126C35.8906 29.1311 36.4782 28.5435 37.3597 28.5435Z",
    fill: "#845BB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp);
export default __webpack_public_path__ + "static/media/temp.8f940f65578af53560c11a51b3b9db1e.svg";
export { ForwardRef as ReactComponent };